import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import './Nav.css';

class Nav extends React.Component {
  render() {
    const { children } = this.props;

    const classes = classNames("navbar", this.props.className, {
      "navbar-dark bg-dark": this.props.dark,
      // "navbar-dark bg-light": this.props.light,
      "navbar-expand-lg": this.props.lg
    });

    return (
      <nav className={classes}>
        {children}
      </nav>
    );
  }
}

Nav.propTypes = {
  dark: PropTypes.bool,
  lg: PropTypes.bool,
};

Nav.defaultProps = {
  dark: false,
  lg: true,
};

export default Nav;
